import React from "react"
import { ArrowProps } from "../../../types"

export const Arrow = (props: ArrowProps) => {
  const rotateString = props.rotate ? `rotate-${props.rotate}` : ""
  return (
    <svg
      className={`w-6 h-6 shrink-0 text-gray-500 ${rotateString}`}
      fill="currentColor"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" />
    </svg>
  )
}

export const LinkIcon = () => {
  return (
    <svg
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      width="24"
      height="24"
      className="text-gray-400 h-[33px] w-[33px] m-auto"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
        d="M13 9l3 3m0 0l-3 3m3-3H8m13 0a9 9 0 11-18 0 9 9 0 0118 0z"
      />
    </svg>
  )
}

export const ChevronUpDownIcon = () => {
  return (
    <svg className="h-5 w-5 text-gray-400" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
      <path
        fillRule="evenodd"
        d="M10 3a.75.75 0 01.55.24l3.25 3.5a.75.75 0 11-1.1 1.02L10 4.852 7.3 7.76a.75.75
          0 01-1.1-1.02l3.25-3.5A.75.75 0 0110 3zm-3.76 9.2a.75.75 0 011.06.04l2.7 2.908
          2.7-2.908a.75.75 0 111.1 1.02l-3.25 3.5a.75.75 0 01-1.1 0l-3.25-3.5a.75.75 0 01.04-1.06z"
        clipRule="evenodd"
      />
    </svg>
  )
}

export const NotificationIcon = ({ color }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth="1.5"
      stroke={color}
      className="w-6 h-6"
      style={{ paddingTop: "2px" }}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M14.857 17.082a23.848 23.848 0 005.454-1.31A8.967 8.967 0 0118 9.75v-.7V9A6
                  6 0 006 9v.75a8.967 8.967 0 01-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714
                  0a24.255 24.255 0 01-5.714 0m5.714 0a3 3 0 11-5.714 0"
      />
    </svg>
  )
}

export const NotificationIconSolid = ({ color }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill={color}
      className="w-6 h-6"
      style={{ paddingTop: "2px" }}
    >
      <path
        fillRule="evenodd"
        d="M5.25 9a6.75 6.75 0 0113.5 0v.75c0 2.123.8 4.057 2.118 5.52a.75.75 0 01-.297 1.206c-1.544.57-3.16.99-4.831 1.243a3.75 3.75 0 11-7.48 0 24.585 24.585 0 01-4.831-1.244.75.75 0 01-.298-1.205A8.217 8.217 0 005.25 9.75V9zm4.502 8.9a2.25 2.25 0 104.496 0 25.057 25.057 0 01-4.496 0z"
        clipRule="evenodd"
      />
    </svg>
  )
}

export const CloseNotificationIcon = ({ color }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth="1.5"
      stroke={color}
      className="w-6 h-6"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M9.75 9.75l4.5 4.5m0-4.5l-4.5 4.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
      />
    </svg>
  )
}

export const PieChartLoading = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="300px"
      height="300px"
      viewBox="0 0 100 100"
      preserveAspectRatio="xMidYMid"
    >
      <circle cx="50" cy="50" r="0" fill="none" stroke="#e4dfff" strokeWidth="2">
        <animate
          attributeName="r"
          repeatCount="indefinite"
          dur="2.6315789473684212s"
          values="0;40"
          keyTimes="0;1"
          keySplines="0 0.2 0.8 1"
          calcMode="spline"
          begin="0s"
        ></animate>
        <animate
          attributeName="opacity"
          repeatCount="indefinite"
          dur="2.6315789473684212s"
          values="1;0"
          keyTimes="0;1"
          keySplines="0.2 0 0.8 1"
          calcMode="spline"
          begin="0s"
        ></animate>
      </circle>
      <circle cx="50" cy="50" r="0" fill="none" stroke="#f0fed8" strokeWidth="2">
        <animate
          attributeName="r"
          repeatCount="indefinite"
          dur="2.6315789473684212s"
          values="0;40"
          keyTimes="0;1"
          keySplines="0 0.2 0.8 1"
          calcMode="spline"
          begin="-1.3157894736842106s"
        ></animate>
        <animate
          attributeName="opacity"
          repeatCount="indefinite"
          dur="2.6315789473684212s"
          values="1;0"
          keyTimes="0;1"
          keySplines="0.2 0 0.8 1"
          calcMode="spline"
          begin="-1.3157894736842106s"
        ></animate>
      </circle>
    </svg>
  )
}

export const PieChartLoading2 = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="300px"
      height="300px"
      viewBox="0 0 100 100"
      preserveAspectRatio="xMidYMid"
    >
      <path fill="none" d="M50 30A20 20 0 0 1 50 70A20 20 0 0 1 50 30" stroke="#f0fed8" strokeWidth="40">
        <animate
          attributeName="stroke-dasharray"
          repeatCount="indefinite"
          dur="1.923076923076923"
          values="0 0 0 126;0 0 126 126;0 126 126 126"
          keyTimes="0;0.5;1"
          keySplines="0.5 0 0.5 1;0.5 0 0.5 1"
          calcMode="spline"
        ></animate>
        <animate
          attributeName="stroke"
          values="#f0fed8;#e4dfff;#fff1e9;#fae1ee;#f0fed8"
          keyTimes="0;0.25;0.5;0.75;1"
          dur="7.692307692307692s"
          calcMode="discrete"
          repeatCount="indefinite"
        ></animate>
      </path>
    </svg>
  )
}

export const CurrencyIcon = (props: { className?: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      data-name="Layer 1"
      viewBox="0 0 64 64"
      id="currency-exchange"
      className={props.className}
    >
      <path d="M32 28.7a14.35 14.35 0 1 1 14.35-14.35A14.37 14.37 0 0 1 32 28.7ZM32 1a13.37 13.37 0 1 0 13.36 13.35A13.38 13.38 0 0 0 32 1Z"></path>
      <path d="M36.26 19.72a3 3 0 0 1 0 .46 1.53 1.53 0 0 1-.08.31.55.55 0 0 1-.12.16.3.3 0 0 1-.16.05h-7.77a.3.3 0 0 1-.16-.05.55.55 0 0 1-.12-.16 1.53 1.53 0 0 1-.08-.31 3 3 0 0 1 0-.46 3.18 3.18 0 0 1 0-.47 1.11 1.11 0 0 1 .07-.3.36.36 0 0 1 .13-.16.24.24 0 0 1 .16-.05h1V15.3h-1a.42.42 0 0 1-.16 0 .44.44 0 0 1-.12-.16 1.3 1.3 0 0 1-.08-.29 3.09 3.09 0 0 1 0-.47 2.81 2.81 0 0 1 0-.45 1.11 1.11 0 0 1 .07-.3.39.39 0 0 1 .13-.15.24.24 0 0 1 .16 0h1v-.98a7.1 7.1 0 0 1 .26-2 3.8 3.8 0 0 1 .76-1.41 3 3 0 0 1 1.25-.81A5.3 5.3 0 0 1 33.13 8a5.46 5.46 0 0 1 .82.06 4.75 4.75 0 0 1 .72.17 4.58 4.58 0 0 1 .59.27 1.82 1.82 0 0 1 .39.27 1.3 1.3 0 0 1 .17.21.76.76 0 0 1 .08.2 1.21 1.21 0 0 1 0 .3v.87a.92.92 0 0 1-.08.3.41.41 0 0 1-.11.16.3.3 0 0 1-.15 0 .51.51 0 0 1-.3-.14 3.53 3.53 0 0 0-.43-.29 3.35 3.35 0 0 0-.6-.3 2.3 2.3 0 0 0-.83-.13 1.85 1.85 0 0 0-.82.16 1.3 1.3 0 0 0-.55.46 2 2 0 0 0-.31.75 4.61 4.61 0 0 0-.1 1v1h2.6a.24.24 0 0 1 .16 0 .31.31 0 0 1 .12.15 1.6 1.6 0 0 1 .08.3 2.81 2.81 0 0 1 0 .45 3.09 3.09 0 0 1 0 .47.9.9 0 0 1-.09.29.3.3 0 0 1-.12.16.33.33 0 0 1-.15 0h-2.6v3.44h4.21a.24.24 0 0 1 .16.05.3.3 0 0 1 .12.16 1.6 1.6 0 0 1 .08.3 3.18 3.18 0 0 1 .07.63zM14.94 62.28a14.35 14.35 0 1 1 14.35-14.35 14.36 14.36 0 0 1-14.35 14.35zm0-27.71A13.37 13.37 0 1 0 28.3 47.93a13.39 13.39 0 0 0-13.36-13.36zm34.12 27.71a14.35 14.35 0 1 1 14.35-14.35 14.36 14.36 0 0 1-14.35 14.35zm0-27.71a13.37 13.37 0 1 0 13.37 13.36 13.38 13.38 0 0 0-13.37-13.36z"></path>
      <path d="M18.86 50.16a3.46 3.46 0 0 1-.27 1.4 3.24 3.24 0 0 1-.79 1.08 3.81 3.81 0 0 1-1.21.72 6 6 0 0 1-1.59.34l-.19 1.93a.24.24 0 0 1-.15.22 1 1 0 0 1-.24.06h-.84a1 1 0 0 1-.27-.08.24.24 0 0 1-.13-.13.28.28 0 0 1 0-.18l.19-1.84a5.25 5.25 0 0 1-.73-.14 4.15 4.15 0 0 1-.62-.19 4.79 4.79 0 0 1-.49-.21 1.29 1.29 0 0 1-.3-.21.6.6 0 0 1-.15-.31A2.83 2.83 0 0 1 11 52v-.5a1 1 0 0 1 .06-.31.31.31 0 0 1 .12-.15.24.24 0 0 1 .15 0 .76.76 0 0 1 .35.13 6 6 0 0 0 .58.3 5.18 5.18 0 0 0 .85.3 4.55 4.55 0 0 0 1.18.14 2.52 2.52 0 0 0 1.57-.4 1.25 1.25 0 0 0 .51-1 1.08 1.08 0 0 0-.22-.71 2 2 0 0 0-.59-.5 6.43 6.43 0 0 0-.83-.38l-1-.35c-.32-.13-.64-.28-1-.44a3.43 3.43 0 0 1-.83-.63 2.63 2.63 0 0 1-.6-.9 3.4 3.4 0 0 1-.22-1.27 3.26 3.26 0 0 1 .35-1.33 2.9 2.9 0 0 1 .65-1 3.16 3.16 0 0 1 1-.67 5.2 5.2 0 0 1 1.45-.33l.18-1.81a.28.28 0 0 1 0-.13.35.35 0 0 1 .11-.09l.23-.06h.85a1.07 1.07 0 0 1 .28.08.24.24 0 0 1 .13.13.57.57 0 0 1 0 .18l-.18 1.71c.17 0 .34.06.53.1a3.55 3.55 0 0 1 .52.15 3.83 3.83 0 0 1 .45.18 1 1 0 0 1 .27.17.79.79 0 0 1 .12.15.53.53 0 0 1 .06.19 1.12 1.12 0 0 1 0 .27V44.05a1.43 1.43 0 0 1-.05.28.23.23 0 0 1-.08.12.2.2 0 0 1-.11 0 .92.92 0 0 1-.34-.11c-.15-.08-.34-.17-.56-.26a6.78 6.78 0 0 0-.76-.25 3.45 3.45 0 0 0-.94-.12 3.09 3.09 0 0 0-.8.09 1.48 1.48 0 0 0-.55.26.88.88 0 0 0-.3.39 1.13 1.13 0 0 0-.1.49 1.16 1.16 0 0 0 .22.72 2 2 0 0 0 .6.49 5.57 5.57 0 0 0 .85.38l1 .36a10.45 10.45 0 0 1 1 .44A3.75 3.75 0 0 1 18 48a2.79 2.79 0 0 1 .6.89 3.14 3.14 0 0 1 .26 1.27zm34.96 2.45a2.56 2.56 0 0 1-.07.69 1.21 1.21 0 0 1-.22.39 2.09 2.09 0 0 1-.4.28 4 4 0 0 1-.64.26 5.62 5.62 0 0 1-.87.2 5.94 5.94 0 0 1-1.08.08 6.18 6.18 0 0 1-2-.28 4.19 4.19 0 0 1-1.47-.82 4.09 4.09 0 0 1-1-1.32 6.75 6.75 0 0 1-.55-1.78h-.94c-.1 0-.18-.07-.24-.19a1.69 1.69 0 0 1-.09-.65 3.79 3.79 0 0 1 0-.38.73.73 0 0 1 0-.25.3.3 0 0 1 .08-.14.22.22 0 0 1 .14-.05h.87V47.26h-.87c-.1 0-.17-.06-.22-.18a1.89 1.89 0 0 1-.07-.64 2.25 2.25 0 0 1 0-.4 1.31 1.31 0 0 1 .06-.25.36.36 0 0 1 .11-.13.2.2 0 0 1 .13 0h1a7 7 0 0 1 .58-1.73 4.56 4.56 0 0 1 1-1.35 4.13 4.13 0 0 1 1.43-.87 5.45 5.45 0 0 1 1.94-.31 6.52 6.52 0 0 1 1.86.26 5.29 5.29 0 0 1 .63.24l.36.21a.56.56 0 0 1 .16.19 1 1 0 0 1 .08.23c0 .09 0 .21.05.35s0 .31 0 .52v.43a1.31 1.31 0 0 1-.07.27.23.23 0 0 1-.11.14.23.23 0 0 1-.14 0 .66.66 0 0 1-.25-.14c-.14-.09-.31-.19-.52-.3a5.45 5.45 0 0 0-.74-.29 3.46 3.46 0 0 0-1-.13 2.76 2.76 0 0 0-1 .15 1.91 1.91 0 0 0-.72.45 2.18 2.18 0 0 0-.48.7 4.15 4.15 0 0 0-.29.94H51a.22.22 0 0 1 .13 0 .27.27 0 0 1 .1.13 1.26 1.26 0 0 1 .07.25v.4a1.57 1.57 0 0 1-.09.64.25.25 0 0 1-.23.18h-2.9V48.61H51a.24.24 0 0 1 .13.05.26.26 0 0 1 .1.14 1 1 0 0 1 .07.25 3.79 3.79 0 0 1 0 .38 1.69 1.69 0 0 1-.09.65.26.26 0 0 1-.23.19h-2.71a3.15 3.15 0 0 0 .27.9 2 2 0 0 0 .49.67 2.09 2.09 0 0 0 .76.43 3.43 3.43 0 0 0 1.07.14 3.39 3.39 0 0 0 1-.13 4.34 4.34 0 0 0 .74-.31c.21-.11.39-.21.53-.3a.63.63 0 0 1 .35-.14.23.23 0 0 1 .14 0 .31.31 0 0 1 .11.15 1.14 1.14 0 0 1 .06.32 4 4 0 0 1 .03.61zM9.14 31.32H9a.5.5 0 0 1-.37-.59 23.85 23.85 0 0 1 5.84-11 .5.5 0 1 1 .72.68 22.83 22.83 0 0 0-5.6 10.52.48.48 0 0 1-.45.39zm45.72 0a.48.48 0 0 1-.48-.38 22.72 22.72 0 0 0-5.6-10.52.49.49 0 1 1 .71-.68 23.81 23.81 0 0 1 5.85 11 .5.5 0 0 1-.38.59zM32 64a23 23 0 0 1-3.13-.21 23.35 23.35 0 0 1-3.52-.73.49.49 0 0 1 .28-.94 22.34 22.34 0 0 0 3.37.69 22.73 22.73 0 0 0 6 0 21.3 21.3 0 0 0 3.38-.71.49.49 0 0 1 .27 1 24.37 24.37 0 0 1-3.52.74A25.55 25.55 0 0 1 32 64z"></path>
    </svg>
  )
}

export const SumIcon = (props: { className?: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fillRule="evenodd"
      strokeLinejoin="round"
      strokeMiterlimit="1"
      clipRule="evenodd"
      viewBox="0 0 32 33"
      id="sigma"
      className={props.className}
    >
      <path d="M4,2c-1.656,0 -3,1.344 -3,3l0,24c0,1.656 1.344,3 3,3l24,0c1.656,0 3,-1.344 3,-3l0,-24c0,-1.656 -1.344,-3 -3,-3l-24,0Zm0,2l24,0c0.552,0 1,0.448 1,1l0,24c0,0.552 -0.448,1 -1,1l-24,0c-0.552,0 -1,-0.448 -1,-1l0,-24c0,-0.552 0.448,-1 1,-1Zm6,3c-0.354,0 -0.681,0.186 -0.861,0.492c-0.18,0.305 -0.184,0.684 -0.012,0.994l4.728,8.514l-4.728,8.514c-0.172,0.31 -0.168,0.689 0.012,0.994c0.18,0.306 0.507,0.492 0.861,0.492l12,0c0.552,0 1,-0.448 1,-1l0,-2c0,-0.552 -0.448,-1 -1,-1c-0.552,0 -1,0.448 -1,1l0,1l-9.301,0l4.174,-7.514c0.168,-0.302 0.168,-0.67 0,-0.972l-4.174,-7.514l9.301,0l0,1c0,0.552 0.448,1 1,1c0.552,0 1,-0.448 1,-1l0,-2c0,-0.552 -0.448,-1 -1,-1l-12,0Z"></path>
    </svg>
  )
}

export const WarningIcon = (props: { className?: string; color?: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill={props.color ? props.color : "currentColor"}
      className={props.className}
    >
      <path
        fillRule="evenodd"
        d="M9.401 3.003c1.155-2 4.043-2 5.197 0l7.355 12.748c1.154 2-.29 4.5-2.599 4.5H4.645c-2.309 0-3.752-2.5-2.598-4.5L9.4 3.003zM12 8.25a.75.75 0 01.75.75v3.75a.75.75 0 01-1.5 0V9a.75.75 0 01.75-.75zm0 8.25a.75.75 0 100-1.5.75.75 0 000 1.5z"
        clipRule="evenodd"
      />
    </svg>
  )
}

export const RefreshIcon = (props: { className?: string; color?: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth="2"
      stroke="currentColor"
      className={props.className}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182m0-4.991v4.99"
      />
    </svg>
  )
}

export const InfoIcon = (props: { className?: string; color?: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      width="100"
      height="100"
      viewBox="0 0 50 50"
      className={props.className}
    >
      <path d="M 25 2 C 12.309295 2 2 12.309295 2 25 C 2 37.690705 12.309295 48 25 48 C 37.690705 48 48 37.690705 48 25 C 48 12.309295 37.690705 2 25 2 z M 25 4 C 36.609824 4 46 13.390176 46 25 C 46 36.609824 36.609824 46 25 46 C 13.390176 46 4 36.609824 4 25 C 4 13.390176 13.390176 4 25 4 z M 25 11 A 3 3 0 0 0 22 14 A 3 3 0 0 0 25 17 A 3 3 0 0 0 28 14 A 3 3 0 0 0 25 11 z M 21 21 L 21 23 L 22 23 L 23 23 L 23 36 L 22 36 L 21 36 L 21 38 L 22 38 L 23 38 L 27 38 L 28 38 L 29 38 L 29 36 L 28 36 L 27 36 L 27 21 L 26 21 L 22 21 L 21 21 z"></path>
    </svg>
  )
}

export const UserAssetIcon = (color?: string) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.20005 8.0001C8.96736 8.0001 10.4 6.56741 10.4 4.8001C10.4 3.03279 8.96736 1.6001 7.20005 1.6001C5.43274 1.6001 4.00005 3.03279 4.00005 4.8001C4.00005 6.56741 5.43274 8.0001 7.20005 8.0001ZM9.60005 11.2001C9.60005 10.3164 10.3164 9.6001 11.2 9.6001C12.0837 9.6001 12.8 10.3164 12.8 11.2001C12.8 12.0838 12.0837 12.8001 11.2 12.8001C10.3164 12.8001 9.60005 12.0838 9.60005 11.2001ZM11.2 8.0001C9.43274 8.0001 8.00005 9.43279 8.00005 11.2001C8.00005 12.9674 9.43274 14.4001 11.2 14.4001C11.7935 14.4001 12.3492 14.2386 12.8256 13.9571L13.8343 14.9658C14.1468 15.2782 14.6533 15.2782 14.9657 14.9658C15.2781 14.6534 15.2781 14.1468 14.9657 13.8344L13.957 12.8257C14.2385 12.3493 14.4 11.7936 14.4 11.2001C14.4 9.43279 12.9674 8.0001 11.2 8.0001ZM2.56222 9.96648C3.63025 9.39383 5.15234 8.8314 7.04147 8.80137C6.63352 9.5071 6.40005 10.3263 6.40005 11.2001C6.40005 12.4295 6.86221 13.5509 7.62227 14.4001H1.84203C1.26656 14.4001 0.800049 13.9336 0.800049 13.3581C0.800049 11.9764 1.34447 10.6194 2.56222 9.96648Z"
        fill={color || "black"}
      />
    </svg>
  )
}

export const AssetRegistryIcon = (color?: string) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.8001 1.6001C4.35827 1.6001 4.0001 1.95827 4.0001 2.4001H12.0001C12.0001 1.95827 11.6419 1.6001 11.2001 1.6001H4.8001ZM1.6001 4.8001C1.6001 3.91644 2.31644 3.2001 3.2001 3.2001H12.8001C13.6838 3.2001 14.4001 3.91644 14.4001 4.8001V12.8001C14.4001 13.6838 13.6838 14.4001 12.8001 14.4001H3.2001C2.31644 14.4001 1.6001 13.6838 1.6001 12.8001V4.8001ZM7.77152 9.86728V6.83458C7.77152 6.64235 7.89178 6.47065 8.07244 6.40496L9.67244 5.82314C9.97058 5.71473 10.2858 5.93552 10.2858 6.25276V7.11187C10.2858 7.30243 10.1676 7.473 9.98918 7.53991L8.60555 8.05877C8.51634 8.09222 8.45724 8.17751 8.45724 8.27278V10.8572C8.45724 11.4884 7.84323 12.0001 7.08581 12.0001C6.32839 12.0001 5.71438 11.4884 5.71438 10.8572C5.71438 10.2261 6.32839 9.71438 7.08581 9.71438C7.33561 9.71438 7.5698 9.77004 7.77152 9.86728Z"
        fill={color || "black"}
      />
    </svg>
  )
}

export const ReleaseUpcIcon = (color?: string) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path
        d="M7.2001 8.0001C7.2001 7.55827 7.55827 7.2001 8.0001 7.2001C8.44192 7.2001 8.8001 7.55827 8.8001 8.0001C8.8001 8.44192 8.44192 8.8001 8.0001 8.8001C7.55827 8.8001 7.2001 8.44192 7.2001 8.0001Z"
        fill={color || "black"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.0001 14.4001C11.5347 14.4001 14.4001 11.5347 14.4001 8.0001C14.4001 4.46548 11.5347 1.6001 8.0001 1.6001C4.46548 1.6001 1.6001 4.46548 1.6001 8.0001C1.6001 11.5347 4.46548 14.4001 8.0001 14.4001ZM8.0001 5.6001C6.67461 5.6001 5.6001 6.67461 5.6001 8.0001C5.6001 9.32558 6.67461 10.4001 8.0001 10.4001C9.32558 10.4001 10.4001 9.32558 10.4001 8.0001C10.4001 6.67461 9.32558 5.6001 8.0001 5.6001ZM10.8285 4.04027C11.1409 3.72785 11.6475 3.72785 11.9599 4.04027C12.306 4.38632 12.6051 4.77624 12.8498 5.20007C13.0708 5.5827 12.9397 6.07198 12.557 6.29289C12.1744 6.5138 11.6851 6.3827 11.4642 6.00007C11.2894 5.69734 11.0757 5.41882 10.8285 5.17164C10.5161 4.85922 10.5161 4.35269 10.8285 4.04027ZM4.536 10.0001C4.31508 9.6175 3.82581 9.4864 3.44318 9.70731C3.06054 9.92823 2.92944 10.4175 3.15036 10.8001C3.39505 11.224 3.69425 11.6139 4.0403 11.9599C4.35272 12.2724 4.85925 12.2724 5.17167 11.9599C5.48409 11.6475 5.48409 11.141 5.17167 10.8286C4.92449 10.5814 4.71078 10.3029 4.536 10.0001Z"
        fill={color || "black"}
      />
    </svg>
  )
}

export const State51BatchIDIcon = (color?: string) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.0001 3.2001C4.0001 2.31644 4.71644 1.6001 5.6001 1.6001H12.8001C13.6838 1.6001 14.4001 2.31644 14.4001 3.2001V10.4001C14.4001 11.2838 13.6838 12.0001 12.8001 12.0001H5.6001C4.71644 12.0001 4.0001 11.2838 4.0001 10.4001V3.2001ZM8.73523 7.09485V4.11902C8.73523 3.83243 8.96756 3.6001 9.25415 3.6001H11.0704C11.357 3.6001 11.5893 3.83243 11.5893 4.11902V5.15686C11.5893 5.44345 11.357 5.67577 11.0704 5.67577H9.77307C9.62977 5.67577 9.51361 5.79194 9.51361 5.93523V8.44334C9.51361 9.30311 8.81663 10.0001 7.95685 10.0001C7.09708 10.0001 6.4001 9.30311 6.4001 8.44334C6.4001 7.58357 7.09708 6.88658 7.95685 6.88658C8.24041 6.88658 8.50625 6.96239 8.73523 7.09485Z"
        fill={color || "black"}
      />
      <path
        d="M3.2001 5.60007C3.2001 5.15825 2.84193 4.80007 2.4001 4.80007C1.95827 4.80007 1.6001 5.15825 1.6001 5.60007V11.2001C1.6001 12.9674 3.03279 14.4001 4.8001 14.4001H10.4001C10.8419 14.4001 11.2001 14.0419 11.2001 13.6001C11.2001 13.1582 10.8419 12.8001 10.4001 12.8001H4.8001C3.91644 12.8001 3.2001 12.0837 3.2001 11.2001V5.60007Z"
        fill={color || "black"}
      />
    </svg>
  )
}

export const TrackISRCIcon = (color?: string) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.5999 3.19995C14.0417 3.19995 14.3999 3.55812 14.3999 3.99995V4.79995C14.3999 5.24178 14.0417 5.59995 13.5999 5.59995H12.3999C12.179 5.59995 11.9999 5.77904 11.9999 5.99995V11.6C11.9999 12.7045 10.9254 13.6 9.5999 13.6C8.27442 13.6 7.1999 12.7045 7.1999 11.6C7.1999 10.4954 8.27442 9.59995 9.5999 9.59995C9.88041 9.59995 10.1497 9.64005 10.3999 9.71376V3.99995C10.3999 3.55812 10.7581 3.19995 11.1999 3.19995H13.5999ZM2.39993 3.33193C2.03101 3.33193 1.73193 3.63101 1.73193 3.99993C1.73193 4.36886 2.03101 4.66793 2.39993 4.66793H8.79993C9.16886 4.66793 9.46793 4.36886 9.46793 3.99993C9.46793 3.63101 9.16886 3.33193 8.79993 3.33193H2.39993ZM2.39993 5.73193C2.03101 5.73193 1.73193 6.03101 1.73193 6.39993C1.73193 6.76886 2.03101 7.06793 2.39993 7.06793H8.79993C9.16886 7.06793 9.46793 6.76886 9.46793 6.39993C9.46793 6.03101 9.16886 5.73193 8.79993 5.73193H2.39993ZM1.73193 8.79993C1.73193 8.43101 2.03101 8.13193 2.39993 8.13193H6.39993C6.76886 8.13193 7.06793 8.43101 7.06793 8.79993C7.06793 9.16886 6.76886 9.46793 6.39993 9.46793H2.39993C2.03101 9.46793 1.73193 9.16886 1.73193 8.79993Z"
        fill={color || "black"}
      />
    </svg>
  )
}

export const PlaylistIcon = (color?: string) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10 4C6.68629 4 4 6.68629 4 10V11H5C6.10457 11 7 11.8954 7 13V16C7 17.1046 6.10457 18 5 18H4C2.89543 18 2 17.1046 2 16V10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10V16C18 17.1046 17.1046 18 16 18H15C13.8954 18 13 17.1046 13 16V13C13 11.8954 13.8954 11 15 11H16V10C16 6.68629 13.3137 4 10 4Z"
        fill={color || "#666666"}
      />
    </svg>
  )
}

export const SchedulerLogsIcon = (color?: string) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.6001 3.9999C1.6001 3.11625 2.31644 2.3999 3.2001 2.3999H12.8001C13.6838 2.3999 14.4001 3.11625 14.4001 3.9999V10.3999C14.4001 11.2836 13.6838 11.9999 12.8001 11.9999H8.8001V12.7999H10.0001C10.221 12.7999 10.4001 12.979 10.4001 13.1999C10.4001 13.4208 10.221 13.5999 10.0001 13.5999H8.8001H7.2001H6.0001C5.77918 13.5999 5.6001 13.4208 5.6001 13.1999C5.6001 12.979 5.77918 12.7999 6.0001 12.7999H7.2001V11.9999H3.2001C2.31644 11.9999 1.6001 11.2836 1.6001 10.3999V3.9999ZM4.13209 9.59993C4.13209 9.23101 4.43117 8.93193 4.80009 8.93193H11.2001C11.569 8.93193 11.8681 9.23101 11.8681 9.59993C11.8681 9.96886 11.569 10.2679 11.2001 10.2679H4.80009C4.43117 10.2679 4.13209 9.96886 4.13209 9.59993Z"
        fill={color || "black"}
      />
    </svg>
  )
}

export const ReportsApprovalIcon = (color?: string) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.6001 2.4001C1.6001 1.95827 1.95827 1.6001 2.4001 1.6001H13.6001C14.0419 1.6001 14.4001 1.95827 14.4001 2.4001C14.4001 2.84193 14.0419 3.2001 13.6001 3.2001V9.6001C13.6001 10.4838 12.8838 11.2001 12.0001 11.2001H10.2753L11.1663 13.3702C11.2933 13.7934 11.0532 14.2394 10.63 14.3664C10.2068 14.4933 9.76079 14.2532 9.63383 13.83L8.60486 11.2001H7.39532L6.36635 13.83C6.23939 14.2532 5.7934 14.4933 5.37021 14.3664C4.94702 14.2394 4.70687 13.7934 4.83383 13.3702L5.72487 11.2001H4.0001C3.11644 11.2001 2.4001 10.4838 2.4001 9.6001V3.2001C1.95827 3.2001 1.6001 2.84193 1.6001 2.4001ZM6.4001 6.4001C6.4001 5.95827 6.04192 5.6001 5.6001 5.6001C5.15827 5.6001 4.8001 5.95827 4.8001 6.4001V8.4001C4.8001 8.84192 5.15827 9.2001 5.6001 9.2001C6.04192 9.2001 6.4001 8.84192 6.4001 8.4001V6.4001ZM8.0001 4.8001C8.44193 4.8001 8.8001 5.15827 8.8001 5.6001V8.4001C8.8001 8.84192 8.44193 9.2001 8.0001 9.2001C7.55827 9.2001 7.2001 8.84192 7.2001 8.4001V5.6001C7.2001 5.15827 7.55827 4.8001 8.0001 4.8001ZM11.2001 4.8001C11.2001 4.35827 10.8419 4.0001 10.4001 4.0001C9.95827 4.0001 9.6001 4.35827 9.6001 4.8001V8.4001C9.6001 8.84192 9.95827 9.2001 10.4001 9.2001C10.8419 9.2001 11.2001 8.84192 11.2001 8.4001V4.8001Z"
        fill={color || "black"}
      />
    </svg>
  )
}

export const UserAdvanceIcon = (color?: string) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M5 2C3.34315 2 2 3.34315 2 5V8V9V16C2 17.1046 2.89543 18 4 18H16C17.1046 18 18 17.1046 18 16V8C18 6.89543 17.1046 6 16 6V5C16 3.34315 14.6569 2 13 2H5ZM14 6V5C14 4.44772 13.5523 4 13 4H5C4.44772 4 4 4.44772 4 5V6H14ZM12 12C12 11.4477 12.4477 11 13 11H15C15.5523 11 16 11.4477 16 12C16 12.5523 15.5523 13 15 13H13C12.4477 13 12 12.5523 12 12Z"
        fill={color || "black"}
      />
    </svg>
  )
}

export const UserTakedownIcon = (color?: string) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="music-library">
      <g id="Vector">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M5 4C5 2.89543 5.89543 2 7 2H16C17.1046 2 18 2.89543 18 4V13C18 14.1046 17.1046 15 16 15H7C5.89543 15 5 14.1046 5 13V4ZM10.9189 8.86844V5.14865C10.9189 4.79041 11.2093 4.5 11.5676 4.5H13.8378C14.1961 4.5 14.4865 4.79041 14.4865 5.14865V6.44595C14.4865 6.80419 14.1961 7.0946 13.8378 7.0946H12.2162C12.0371 7.0946 11.8919 7.2398 11.8919 7.41892V10.5541C11.8919 11.6288 11.0207 12.5 9.94595 12.5C8.87123 12.5 8 11.6288 8 10.5541C8 9.47934 8.87123 8.60811 9.94595 8.60811C10.3004 8.60811 10.6327 8.70287 10.9189 8.86844Z"
            fill={color || "black"}
          />
          <path
            d="M4 6.99997C4 6.44768 3.55228 5.99997 3 5.99997C2.44772 5.99997 2 6.44768 2 6.99997V14C2 16.2091 3.79086 18 6 18H13C13.5523 18 14 17.5523 14 17C14 16.4477 13.5523 16 13 16H6C4.89543 16 4 15.1045 4 14V6.99997Z"
            fill={color || "black"}
          />
      </g>
      </g>
    </svg>
  )
}

export const State51DeliveryIcon = (color?: string) => {
  return (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 97.75 97.75"
      >
      <g>
        <g>
          <path d="M48.875,0C21.883,0,0,21.883,0,48.875S21.883,97.75,48.875,97.75S97.75,75.867,97.75,48.875S75.867,0,48.875,0z
            M62.02,83.367c-0.552-12.695-10.123,0-10.123,0H48.99h-0.22h-2.916c0,0-9.567-12.695-10.12,0c0,0-20.787-2.854-20.787-32.557
            c0-29.708,17.016-33.207,17.016-33.207s0.826,9.335,8.926,8.184c0,0-2.951-4.41,0-11.405c0,0,3.268,5.598,7.985,5.688
            c4.722-0.091,7.989-5.688,7.989-5.688c2.951,6.995,0,11.405,0,11.405c8.099,1.151,8.926-8.184,8.926-8.184
            s17.016,3.498,17.016,33.207C82.805,80.514,62.02,83.367,62.02,83.367z" fill={color || "black"}/>
          <path d="M56.824,39.457l-0.053,5.145h6.478v25.916h7.244V35.658C70.493,37.732,56.824,39.457,56.824,39.457z" fill={color || "black"}/>
          <path d="M46.698,50.01c-2.677-1.535-6.144-2.226-9.611-2.226c-1.154,0-1.943,0.052-2.854,0.156l-0.064-6.883h16.42v-5.399H27.127
            l-0.029,17.369c1.577-0.215,3.669-0.319,5.855-0.319c7.903,0,11.254,2.597,11.254,6.512c0,4.132-4.2,6.304-8.577,6.304
            c-3.592,0-6.993-1.008-8.696-1.801l-1.522,4.924c2.064,1.009,5.898,2.019,10.461,2.019c9.73,0,15.993-5.349,15.993-11.918
            C51.865,54.562,49.675,51.646,46.698,50.01z" fill={color || "black"}/>
        </g>
      </g>
    </svg>
  )
}

export const RoyaltyReportsIcon = (color?: string) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.2001 1.6001C2.31644 1.6001 1.6001 2.31644 1.6001 3.2001V12.8001C1.6001 13.6838 2.31644 14.4001 3.2001 14.4001H12.8001C13.6838 14.4001 14.4001 13.6838 14.4001 12.8001V3.2001C14.4001 2.31644 13.6838 1.6001 12.8001 1.6001H3.2001ZM4.8001 6.4001C4.35827 6.4001 4.0001 6.75827 4.0001 7.2001V11.2001C4.0001 11.6419 4.35827 12.0001 4.8001 12.0001C5.24193 12.0001 5.6001 11.6419 5.6001 11.2001V7.2001C5.6001 6.75827 5.24193 6.4001 4.8001 6.4001ZM7.2001 4.8001C7.2001 4.35827 7.55827 4.0001 8.0001 4.0001C8.44193 4.0001 8.8001 4.35827 8.8001 4.8001V11.2001C8.8001 11.6419 8.44193 12.0001 8.0001 12.0001C7.55827 12.0001 7.2001 11.6419 7.2001 11.2001V4.8001ZM11.2001 8.0001C10.7583 8.0001 10.4001 8.35827 10.4001 8.8001V11.2001C10.4001 11.6419 10.7583 12.0001 11.2001 12.0001C11.6419 12.0001 12.0001 11.6419 12.0001 11.2001V8.8001C12.0001 8.35827 11.6419 8.0001 11.2001 8.0001Z"
        fill={color || "black"}
      />
    </svg>
  )
}

export const ReleaseSubmissionIcon = (color?: string) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M22.8284 5.9997C21.2663 4.4376 18.7337 4.4376 17.1716 5.9997L10.5858 12.5855C9.80474 13.3665 9.80474 14.6329 10.5858 15.4139C11.3668 16.195 12.6332 16.195 13.4142 15.4139L18 10.8281V23.9998C18 25.1043 18.8954 25.9998 20 25.9998C21.1046 25.9998 22 25.1043 22 23.9998V10.8281L26.5858 15.4139C27.3668 16.195 28.6332 16.195 29.4142 15.4139C30.1953 14.6329 30.1953 13.3665 29.4142 12.5855L22.8284 5.9997ZM6 19.9998C7.10457 19.9998 8 20.8952 8 21.9998V29.9998C8 31.1043 8.89543 31.9998 10 31.9998H30C31.1046 31.9998 32 31.1043 32 29.9998V21.9998C32 20.8952 32.8954 19.9998 34 19.9998C35.1046 19.9998 36 20.8952 36 21.9998V29.9998C36 33.3135 33.3137 35.9998 30 35.9998H10C6.68629 35.9998 4 33.3135 4 29.9998V21.9998C4 20.8952 4.89543 19.9998 6 19.9998Z"
        fill={color || "black"}
      />
    </svg>
  )
}

export const TerritoryDSPListIcon = (color?: string) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.3359 7.09076C13.9672 4.49784 12.0444 2.40539 9.54074 1.78662C9.8532 2.17786 10.1124 2.67959 10.3225 3.23991C10.7844 4.4716 11.0595 6.12255 11.0678 7.91657C12.3083 7.73621 13.4187 7.45064 14.3359 7.09076ZM9.73189 8.06505C9.73197 8.04338 9.73201 8.02168 9.73201 7.99995C9.73201 6.29153 9.4712 4.77461 9.0716 3.70901C8.87088 3.17375 8.64798 2.78699 8.43436 2.54604C8.22005 2.30432 8.07175 2.26795 8.00001 2.26795C7.92828 2.26795 7.77997 2.30432 7.56566 2.54604C7.35204 2.78699 7.12915 3.17375 6.92842 3.70901C6.52883 4.77461 6.26801 6.29153 6.26801 7.99995C6.26801 8.02168 6.26806 8.04338 6.26814 8.06505C6.82769 8.10887 7.40658 8.13195 8.00001 8.13195C8.59345 8.13195 9.17233 8.10887 9.73189 8.06505ZM6.32886 9.40927C6.87342 9.44793 7.43178 9.46795 8.00001 9.46795C8.56825 9.46795 9.12661 9.44793 9.67117 9.40927C9.57191 10.5371 9.3572 11.5293 9.0716 12.2909C8.87088 12.8261 8.64798 13.2129 8.43436 13.4538C8.22005 13.6956 8.07175 13.7319 8.00001 13.7319C7.92828 13.7319 7.77997 13.6956 7.56566 13.4538C7.35204 13.2129 7.12915 12.8261 6.92842 12.2909C6.64282 11.5293 6.42812 10.5371 6.32886 9.40927ZM4.93221 7.91657C4.94048 6.12255 5.2156 4.4716 5.67749 3.23991C5.88761 2.67959 6.14683 2.17785 6.45929 1.78662C3.95566 2.40539 2.03286 4.49784 1.6641 7.09076C2.58133 7.45064 3.69177 7.73621 4.93221 7.91657ZM14.3809 8.49843C14.1667 11.2792 12.1753 13.5621 9.54074 14.2133C9.8532 13.822 10.1124 13.3203 10.3225 12.76C10.6803 11.806 10.926 10.6005 11.0224 9.2718C12.2566 9.10693 13.3937 8.84298 14.3809 8.49843ZM1.61914 8.49843C2.60633 8.84298 3.74344 9.10693 4.97758 9.2718C5.07404 10.6005 5.31974 11.806 5.67749 12.76C5.88761 13.3203 6.14683 13.822 6.45929 14.2133C3.82474 13.5621 1.83337 11.2792 1.61914 8.49843Z"
        fill={color || "black"}
      />
    </svg>
  )
}

export const RegistrationsIcon = (color?: string) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path
        d="M5.60007 7.1999C6.92556 7.1999 8.00007 6.12539 8.00007 4.7999C8.00007 3.47442 6.92556 2.3999 5.60007 2.3999C4.27459 2.3999 3.20007 3.47442 3.20007 4.7999C3.20007 6.12539 4.27459 7.1999 5.60007 7.1999Z"
        fill={color || "black"}
      />
      <path
        d="M11.2001 6.3999C12.0837 6.3999 12.8001 5.68356 12.8001 4.7999C12.8001 3.91625 12.0837 3.1999 11.2001 3.1999C10.3164 3.1999 9.60007 3.91625 9.60007 4.7999C9.60007 5.68356 10.3164 6.3999 11.2001 6.3999Z"
        fill={color || "black"}
      />
      <path
        d="M8.80008 12.7999C9.68373 12.7999 10.425 12.0644 10.1359 11.2294C10.1048 11.1397 10.0711 11.0509 10.0347 10.963C9.79348 10.3807 9.43991 9.85151 8.99419 9.40579C8.54847 8.96007 8.01932 8.6065 7.43696 8.36528C6.85459 8.12406 6.23042 7.9999 5.60008 7.9999C4.96973 7.9999 4.34556 8.12406 3.7632 8.36528C3.18083 8.6065 2.65169 8.96007 2.20596 9.40579C1.76024 9.85151 1.40668 10.3807 1.16546 10.963C1.12906 11.0509 1.09533 11.1397 1.06429 11.2294C0.775157 12.0644 1.51642 12.7999 2.40008 12.7999H8.80008Z"
        fill={color || "black"}
      />
      <path
        d="M13.1434 10.3999H11.5349C11.1002 9.326 10.3824 8.39695 9.47417 7.70523C9.63284 7.6036 9.80056 7.51594 9.97548 7.44349C10.3637 7.28267 10.7798 7.1999 11.2001 7.1999C11.6203 7.1999 12.0364 7.28267 12.4247 7.44349C12.8129 7.6043 13.1657 7.84001 13.4628 8.13716C13.76 8.43431 13.9957 8.78707 14.1565 9.17532C14.4221 9.8165 13.8375 10.3999 13.1434 10.3999Z"
        fill={color || "black"}
      />
    </svg>
  )
}

export const UserTypeIcon = (color?: string) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.49998 8.0001C10.2673 8.0001 11.7 6.56741 11.7 4.8001C11.7 3.03279 10.2673 1.6001 8.49998 1.6001C6.73266 1.6001 5.29998 3.03279 5.29998 4.8001C5.29998 6.56741 6.73266 8.0001 8.49998 8.0001ZM3.86215 9.96647C2.6444 10.6194 2.09998 11.9764 2.09998 13.3581C2.09998 13.9336 2.56649 14.4001 3.14196 14.4001H13.858C14.4335 14.4001 14.9 13.9336 14.9 13.3581C14.9 11.9764 14.3556 10.6194 13.1378 9.96647C12.0401 9.37789 10.4626 8.8001 8.49998 8.8001C6.53734 8.8001 4.9599 9.37789 3.86215 9.96647Z"
        fill={color || "#666"}
      />
    </svg>
  )
}

export const DailyTrendsIcon = (color?: string) => {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 122.88 120.5"
      width="20"
      height="20"
    >
      <g>
        <path
          d="M64.82,68.27l48.4,0.8c0,17.19-8.55,33.26-22.81,42.86L64.82,68.27L64.82,68.27z M59.99,59.92L59.44,3.63 L59.41,0l3.61,0.25h0.01h0.01c4.56,0.32,8.98,1.12,13.21,2.33c4.23,1.21,8.29,2.86,12.13,4.87c19.67,10.34,33.27,30.56,34.34,54.02 l0.16,3.61l-3.61-0.11l-56.02-1.72l-3.23-0.1L59.99,59.92L59.99,59.92z M66.19,7.33l0.48,49.31l49.06,1.5 c-2.1-19.45-13.88-36.02-30.48-44.74c-3.41-1.79-7.04-3.26-10.84-4.35C71.74,8.28,69,7.71,66.19,7.33L66.19,7.33z M55.19,65.31 l27.6,47.8c-8.38,4.84-17.92,7.39-27.6,7.39C24.71,120.5,0,95.78,0,65.31c0-29.57,23.31-53.9,52.86-55.14L55.19,65.31L55.19,65.31z"
          fill={color || "#666666"}
        />
      </g>
    </svg>
  )
}
